export default __webpack_public_path__ + "static/media/todopago_ar.91e5ba17.png";